/**
 * YD Product Slider - GSAP 无限循环轮播
 * 中间亮两边暗效果，支持拖拽和惯性
 */
(function () {
  'use strict';

  // Line Reveal 相关变量
  let splitTextInstances = [];
  let titlesRevealed = false;

  /**
   * 初始化 SplitText - 为标题元素拆分行
   */
  function initSplitText() {
    if (typeof SplitText === 'undefined') {
      return;
    }

    const titles = document.querySelectorAll('.yd-product-slider__title');
    if (titles.length === 0) return;

    titles.forEach((el) => {
      // 使用 SplitText 按行拆分
      const split = new SplitText(el, {
        type: 'lines',
        linesClass: 'yd-line',
      });

      // 为每行创建内部 wrapper
      split.lines.forEach((line) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'yd-line-inner';
        wrapper.innerHTML = line.innerHTML;
        line.innerHTML = '';
        line.appendChild(wrapper);
      });

      splitTextInstances.push(split);

      // 初始化内部元素位置（隐藏）
      gsap.set(el.querySelectorAll('.yd-line-inner'), { yPercent: 100 });
    });
  }

  /**
   * 播放 Line Reveal 动画
   */
  function playTitleLineReveal() {
    if (titlesRevealed) return;

    const inners = document.querySelectorAll('.yd-product-slider__header .yd-line-inner');
    if (inners.length === 0) return;

    titlesRevealed = true;

    gsap.fromTo(
      inners,
      { yPercent: 100 },
      {
        yPercent: 0,
        duration: 0.8,
        stagger: 0.12,
        ease: 'power3.out',
      }
    );
  }

  /**
   * 设置标题入场观察器
   */
  function setupTitleObserver() {
    const header = document.querySelector('.yd-product-slider__header');
    if (!header) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !titlesRevealed) {
            playTitleLineReveal();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(header);
  }

  let _sliderRetries = 0;
  const _sliderMaxRetries = 50; // 最多等待 5 秒

  function initProductSlider() {
    // 等待 GSAP 和插件加载（有上限）
    if (typeof gsap === 'undefined' || typeof Draggable === 'undefined') {
      if (++_sliderRetries > _sliderMaxRetries) {
        console.warn('[ProductSlider] GSAP/Draggable not loaded after 5s, aborting');
        return;
      }
      setTimeout(initProductSlider, 100);
      return;
    }

    // 注册插件
    gsap.registerPlugin(Draggable);
    if (typeof InertiaPlugin !== 'undefined') {
      gsap.registerPlugin(InertiaPlugin);
    }

    // 初始化 Line Reveal
    initSplitText();
    setupTitleObserver();

    const section = document.querySelector('#product-slider-section');
    const wrapper = document.querySelector('[data-slider="list"]');
    const slides = gsap.utils.toArray('[data-slider="slide"]');

    if (!wrapper || slides.length === 0) return;

    // 读取自动轮播设置
    const autoplayEnabled = section?.dataset.autoplay === 'true';
    const autoplayInterval = parseFloat(section?.dataset.autoplayInterval) || 4;
    const pauseOnHover = section?.dataset.pauseOnHover === 'true';

    let activeElement;
    let autoplayTimer = null;
    let isAutoplayPaused = false;

    // 统一管理 context 外的 DOM 监听器：用一个 AbortController 的 signal 绑定，
    // section unload 时 abort() 一次性移除全部（wrapper pointer / nav / slide / lightbox /
    // document keydown / wishlist），避免编辑器 reload 累积监听与重复绑定。
    const listenerAbort = new AbortController();
    const sig = listenerAbort.signal;

    // 创建无限循环 - center: true 让当前项居中显示
    const loop = horizontalLoop(slides, {
      paused: true,
      draggable: true,
      center: true,
      onChange: (element, index) => {
        // 更新激活状态 - 直接高亮当前居中的元素
        if (activeElement) {
          activeElement.classList.remove('active');
        }
        element.classList.add('active');
        activeElement = element;
      },
    });

    // section 卸载时清理资源
    if (section) {
      var sliderSection = section.closest('.shopify-section');
      if (sliderSection) {
        sliderSection.addEventListener('shopify:section:unload', () => {
          stopAutoplay();  // 清 gsap.delayedCall（在 context 外创建，revert 不覆盖）
          // 一次性移除所有 context 外 DOM 监听器（wrapper/nav/slide/lightbox/keydown/wishlist）
          listenerAbort.abort();
          // revert 还原 horizontalLoop context 内的 timeline / Draggable，
          // 并触发其 cleanup 移除 resize 监听，避免编辑器 reload 累积泄漏
          if (loop && loop.cleanupCtx) {
            try { loop.cleanupCtx.revert(); } catch (e) {}
          }
        });
      }
    }

    // ========== 自动轮播功能（gsap.delayedCall 替代 setInterval） ==========
    function scheduleNextAutoplay() {
      if (!autoplayEnabled) return;
      autoplayTimer = gsap.delayedCall(autoplayInterval, () => {
        if (!isAutoplayPaused) {
          loop.next({ duration: 0.725, ease: 'power3.inOut' });
        }
        scheduleNextAutoplay();
      });
    }

    function startAutoplay() {
      if (!autoplayEnabled || autoplayTimer) return;
      scheduleNextAutoplay();
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        autoplayTimer.kill();
        autoplayTimer = null;
      }
    }

    function pauseAutoplay() {
      isAutoplayPaused = true;
    }

    function resumeAutoplay() {
      isAutoplayPaused = false;
    }

    // 悬停暂停功能
    if (pauseOnHover && autoplayEnabled) {
      wrapper.addEventListener('mouseenter', pauseAutoplay, { signal: sig });
      wrapper.addEventListener('mouseleave', resumeAutoplay, { signal: sig });
    }

    // 拖拽时暂停自动轮播
    if (autoplayEnabled) {
      wrapper.addEventListener('pointerdown', pauseAutoplay, { signal: sig });
      wrapper.addEventListener('pointerup', () => {
        // 延迟恢复，等待拖拽惯性动画完成
        setTimeout(resumeAutoplay, 1000);
      }, { signal: sig });
      wrapper.addEventListener('pointercancel', () => {
        setTimeout(resumeAutoplay, 1000);
      }, { signal: sig });
    }

    // 启动自动轮播
    if (autoplayEnabled) {
      startAutoplay();
    }

    // ========== 导航按钮功能 ==========
    const prevBtn = document.querySelector('[data-slider-nav="prev"]');
    const nextBtn = document.querySelector('[data-slider-nav="next"]');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        loop.previous({ duration: 0.725, ease: 'power3.inOut' });
      }, { signal: sig });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        loop.next({ duration: 0.725, ease: 'power3.inOut' });
      }, { signal: sig });
    }

    // Lightbox 弹窗功能 - 移动到 body 最外层避免 ScrollSmoother 影响
    const lightbox = document.querySelector('[data-lightbox]');
    if (lightbox && lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }
    const lightboxImage = document.querySelector('[data-lightbox-image]');
    const lightboxClose = document.querySelector('[data-lightbox-close]');

    function openLightbox(img) {
      // 获取原始图片 src 并替换为高分辨率
      const originalSrc = img.getAttribute('src') || img.src;
      const highResSrc = originalSrc.replace(/width=\d+/, 'width=2560');

      lightboxImage.src = highResSrc;
      lightboxImage.alt = img.alt || 'Product image';
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';

      // 打开 Lightbox 时暂停自动轮播
      pauseAutoplay();
    }

    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';

      // 关闭 Lightbox 时恢复自动轮播
      resumeAutoplay();
    }

    // 点击图片打开 lightbox（区分点击和拖拽）
    slides.forEach((slide, i) => {
      let isDragging = false;
      let startX = 0;

      slide.addEventListener('pointerdown', (e) => {
        isDragging = false;
        startX = e.clientX;
      }, { signal: sig });

      slide.addEventListener('pointermove', (e) => {
        if (Math.abs(e.clientX - startX) > 5) {
          isDragging = true;
        }
      }, { signal: sig });

      slide.addEventListener('click', (e) => {
        // 如果是拖拽操作，不打开 lightbox
        if (isDragging) {
          isDragging = false;
          return;
        }

        // 只有点击高亮(active)的图片才弹出
        if (!slide.classList.contains('active')) {
          // 非高亮图片点击时跳转到该位置
          loop.toIndex(i, { ease: 'power3', duration: 0.725 });
          return;
        }

        const img = slide.querySelector('img');
        if (img) {
          e.stopPropagation();
          openLightbox(img);
        }
      }, { signal: sig });
    });

    // 关闭 lightbox 的事件（判空：lightbox DOM 可能未渲染，避免中断后续 Klaviyo 绑定）
    if (lightbox && lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox, { signal: sig });
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      }, { signal: sig });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox.classList.contains('active')) {
          closeLightbox();
        }
      }, { signal: sig });
    }

    // Klaviyo Popup 表单 - Wishlist 按钮
    const wishlistBtn = document.querySelector('.yd-product-slider__button[data-klaviyo-form-id]');
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const formId = this.dataset.klaviyoFormId;
        if (!formId) {
          return;
        }

        // 使用 Klaviyo API 打开 popup 表单
        if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
          window._klOnsite.openForm(formId);
        } else {
          // 备用：使用 klaviyo 队列
          window.klaviyo = window.klaviyo || [];
          window.klaviyo.push(['openForm', formId]);
        }
      }, { signal: sig });
    }
  }

  /**
   * 创建水平无限循环
   */
  function horizontalLoop(items, config) {
    let timeline;
    items = gsap.utils.toArray(items);
    config = config || {};

    const ctx = gsap.context(() => {
      let onChange = config.onChange,
        lastIndex = 0,
        tl = gsap.timeline({
          repeat: config.repeat,
          onUpdate:
            onChange &&
            function () {
              let i = tl.closestIndex();
              if (lastIndex !== i) {
                lastIndex = i;
                onChange(items[i], i);
              }
            },
          paused: config.paused,
          defaults: { ease: 'none' },
          onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
        }),
        length = items.length,
        startX = items[0].offsetLeft,
        times = [],
        widths = [],
        spaceBefore = [],
        xPercents = [],
        curIndex = 0,
        indexIsDirty = false,
        center = config.center,
        pixelsPerSecond = (config.speed || 1) * 100,
        snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1),
        timeOffset = 0,
        container = center === true ? items[0].parentNode : gsap.utils.toArray(center)[0] || items[0].parentNode,
        totalWidth,
        getTotalWidth = () =>
          items[length - 1].offsetLeft +
          (xPercents[length - 1] / 100) * widths[length - 1] -
          startX +
          spaceBefore[0] +
          items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') +
          (parseFloat(config.paddingRight) || 0),
        populateWidths = () => {
          let b1 = container.getBoundingClientRect(),
            b2;
          items.forEach((el, i) => {
            widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px'));
            xPercents[i] = snap(
              (parseFloat(gsap.getProperty(el, 'x', 'px')) / widths[i]) * 100 + gsap.getProperty(el, 'xPercent')
            );
            b2 = el.getBoundingClientRect();
            spaceBefore[i] = b2.left - (i ? b1.right : b1.left);
            b1 = b2;
          });
          gsap.set(items, { xPercent: (i) => xPercents[i] });
          totalWidth = getTotalWidth();
        },
        timeWrap,
        populateOffsets = () => {
          timeOffset = center ? (tl.duration() * (container.offsetWidth / 2)) / totalWidth : 0;
          center &&
            times.forEach((t, i) => {
              times[i] = timeWrap(tl.labels['label' + i] + (tl.duration() * widths[i]) / 2 / totalWidth - timeOffset);
            });
        },
        getClosest = (values, value, wrap) => {
          let i = values.length,
            closest = 1e10,
            index = 0,
            d;
          while (i--) {
            d = Math.abs(values[i] - value);
            if (d > wrap / 2) {
              d = wrap - d;
            }
            if (d < closest) {
              closest = d;
              index = i;
            }
          }
          return index;
        },
        populateTimeline = () => {
          let i, item, curX, distanceToStart, distanceToLoop;
          tl.clear();
          for (i = 0; i < length; i++) {
            item = items[i];
            curX = (xPercents[i] / 100) * widths[i];
            distanceToStart = item.offsetLeft + curX - startX + spaceBefore[0];
            distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX');
            tl.to(
              item,
              {
                xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
                duration: distanceToLoop / pixelsPerSecond,
              },
              0
            )
              .fromTo(
                item,
                { xPercent: snap(((curX - distanceToLoop + totalWidth) / widths[i]) * 100) },
                {
                  xPercent: xPercents[i],
                  duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
                  immediateRender: false,
                },
                distanceToLoop / pixelsPerSecond
              )
              .add('label' + i, distanceToStart / pixelsPerSecond);
            times[i] = distanceToStart / pixelsPerSecond;
          }
          timeWrap = gsap.utils.wrap(0, tl.duration());
        },
        refresh = (deep) => {
          let progress = tl.progress();
          tl.progress(0, true);
          populateWidths();
          deep && populateTimeline();
          populateOffsets();
          deep && tl.draggable ? tl.time(times[curIndex], true) : tl.progress(progress, true);
        },
        onResize = () => refresh(true),
        proxy;

      gsap.set(items, { x: 0 });
      populateWidths();
      populateTimeline();
      populateOffsets();
      // 200ms debounce 避免移动端地址栏滚动狂触发 resize → refresh(true)
      let _sliderResizeTimer = null;
      const debouncedResize = () => {
        clearTimeout(_sliderResizeTimer);
        _sliderResizeTimer = setTimeout(onResize, 200);
      };
      window.addEventListener('resize', debouncedResize);

      function toIndex(index, vars) {
        vars = vars || {};
        Math.abs(index - curIndex) > length / 2 && (index += index > curIndex ? -length : length);
        let newIndex = gsap.utils.wrap(0, length, index),
          time = times[newIndex];
        if (time > tl.time() !== index > curIndex && index !== curIndex) {
          time += tl.duration() * (index > curIndex ? 1 : -1);
        }
        if (time < 0 || time > tl.duration()) {
          vars.modifiers = { time: timeWrap };
        }
        curIndex = newIndex;
        vars.overwrite = true;
        gsap.killTweensOf(proxy);
        return vars.duration === 0 ? tl.time(timeWrap(time)) : tl.tweenTo(time, vars);
      }

      tl.toIndex = (index, vars) => toIndex(index, vars);
      tl.closestIndex = (setCurrent) => {
        let index = getClosest(times, tl.time(), tl.duration());
        if (setCurrent) {
          curIndex = index;
          indexIsDirty = false;
        }
        return index;
      };
      tl.current = () => (indexIsDirty ? tl.closestIndex(true) : curIndex);
      tl.next = (vars) => toIndex(tl.current() + 1, vars);
      tl.previous = (vars) => toIndex(tl.current() - 1, vars);
      tl.times = times;
      tl.progress(1, true).progress(0, true);

      if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
      }

      // 拖拽功能
      if (config.draggable && typeof Draggable === 'function') {
        proxy = document.createElement('div');
        let wrap = gsap.utils.wrap(0, 1),
          ratio,
          startProgress,
          draggable,
          lastSnap,
          initChangeX,
          wasPlaying,
          align = () => tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio)),
          syncIndex = () => tl.closestIndex(true);

        const draggableConfig = {
          trigger: items[0].parentNode,
          type: 'x',
          onPressInit() {
            let x = this.x;
            gsap.killTweensOf(tl);
            wasPlaying = !tl.paused();
            tl.pause();
            startProgress = tl.progress();
            refresh();
            ratio = 1 / totalWidth;
            initChangeX = startProgress / -ratio - x;
            gsap.set(proxy, { x: startProgress / -ratio });
          },
          onDrag: align,
          onThrowUpdate: align,
          overshootTolerance: 0,
          snap(value) {
            if (Math.abs(startProgress / -ratio - this.x) < 10) {
              return lastSnap + initChangeX;
            }
            let time = -(value * ratio) * tl.duration(),
              wrappedTime = timeWrap(time),
              snapTime = times[getClosest(times, wrappedTime, tl.duration())],
              dif = snapTime - wrappedTime;
            Math.abs(dif) > tl.duration() / 2 && (dif += dif < 0 ? tl.duration() : -tl.duration());
            lastSnap = (time + dif) / tl.duration() / -ratio;
            return lastSnap;
          },
          onRelease() {
            syncIndex();
            draggable.isThrowing && (indexIsDirty = true);
          },
          onThrowComplete: () => {
            syncIndex();
            wasPlaying && tl.play();
          },
        };

        // 如果有 InertiaPlugin 则启用惯性
        if (typeof InertiaPlugin !== 'undefined') {
          draggableConfig.inertia = true;
        }

        draggable = Draggable.create(proxy, draggableConfig)[0];
        tl.draggable = draggable;
      }

      tl.closestIndex(true);
      lastIndex = curIndex;
      onChange && onChange(items[curIndex], curIndex);
      timeline = tl;
      // cleanup 移除实际注册的 debouncedResize（此前误写 onResize，引用不匹配移除无效），
      // 并清掉可能挂起的 debounce 定时器
      return () => {
        window.removeEventListener('resize', debouncedResize);
        clearTimeout(_sliderResizeTimer);
      };
    });

    // 暴露 context 供 section unload 时 revert（还原所有 GSAP + 触发上面的 cleanup）
    if (timeline) timeline.cleanupCtx = ctx;
    return timeline;
  }

  // DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSlider);
  } else {
    initProductSlider();
  }
})();
